// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","869":"styles"}[chunkId] + "-" + {"245":"68f4db99ee1d359688b7","453":"05e87c48a6e656fa903c","869":"d8c7a0db0b9a5455b295"}[chunkId] + ".js";
};